// APIs
import { LineageOptions, ProductType, ProductTypeOptions, Options } from './types'
import { SearchFunc } from './redux/types/ui'

export const API_PRODUCTS = '/api/products'
export const API_BRANDS = '/api/product_brands'
export const API_BRAND_SEARCH = '/api/product_brands/search'
export const API_ALIASES = '/api/products/aliases'
export const API_PRODUCT_ALIASES = '/api/product-aliases'
export const API_WHOAMI = '/api/whoami'
export const API_LOGIN = '/api/login'
export const API_LOGOUT = '/api/logout'
export const API_S3_UPLOAD = '/api/s3_upload'
export const API_BRAND_LOGO_S3_UPLOAD = '/api/brand-logo-s3'
export const API_PRODUCT_NOTICES = '/api/products/notices'
export const API_PRODUCT_MERGE = '/api/products/merge'
export const API_POST_ZIP_FILE = '/api/zip-to-s3'
export const API_LOCALIZATIONS = '/api/catalog_product_localizations'

// Paths
export const PATH_ROOT = '/'
export const PATH_PRODUCTS = '/products'
export const PATH_BATCH_LOOKUP = '/batch-lookup'
export const PATH_PRODUCTS_CREATE = '/products/create'
export const PATH_PRODUCT_NOTICES = '/products/notices'
export const PATH_BRAND_THEMES = '/products/brand-themes'
export const PATH_BATCH_PRODUCT_CREATOR = '/products/batch-creator'
export const PATH_BULK_EDITOR = '/products/bulk-editor'
export const PATH_CLUMP_EDITOR = '/products/clump-editor'

export const PATH_PRODUCTS_NEW = '/products/new'
export const PATH_PRODUCTS_EDIT = '/products/edit'
export const PATH_PRODUCTS_ALIAS_REMAP = '/products/:productId/aliases/remap'

export const PATH_FEATURE_FLAGS = '/flags'

export const SWITCH_TO_EDIT = 'Switch to Edit'
export const SWITCH_TO_CREATE = 'Switch to Create'

export const BATCH_REQUEST_DELAY: Record<SearchFunc, number> = {
  sql: 1000,
  algolia: 250,
}

export const PRODUCT_TYPE_OPTIONS: ProductTypeOptions[] = [
  { id: '', key: '', text: '', value: '' },
  { id: 0, key: 'flower', text: 'Flower', value: 'flower' },
  { id: 1, key: 'edible', text: 'Edible', value: 'edible' },
  { id: 2, key: 'extract', text: 'Extract', value: 'extract' },
  { id: 3, key: 'merch', text: 'Merch', value: 'merch' },
  { id: 4, key: 'grow', text: 'Grow', value: 'grow' },
  { id: 5, key: 'tincture', text: 'Tincture', value: 'tincture' },
  { id: 6, key: 'gear', text: 'Gear', value: 'gear' },
  { id: 7, key: 'topical', text: 'Topical', value: 'topical' },
  { id: 8, key: 'pre-roll', text: 'Pre-roll', value: 'pre-roll' },
  { id: 9, key: 'vape', text: 'Vape', value: 'vape' },
]

export const LINEAGE_OPTIONS: LineageOptions[] = [
  { id: 0, key: 'indica', text: 'Indica', value: 'indica' },
  { id: 1, key: 'sativa', text: 'Sativa', value: 'sativa' },
  { id: 2, key: 'hybrid', text: 'Hybrid', value: 'hybrid' },
  { id: 3, key: 'cbd', text: 'CBD', value: 'cbd' },
]

export const QUANTITY_UNIT_OPTIONS: Options[] = [
  { key: '', text: '', value: '' },
  { key: 'g', text: 'Gram (weight)', value: 'g' },
  { key: 'oz', text: 'Ounce (weight)', value: 'oz' },
  { key: 'fl_oz', text: 'Fluid ounce (volume)', value: 'fl_oz' },
  { key: 'ml', text: 'Milliliter (volume)', value: 'ml' },
  { key: 'mg', text: 'Milligram (dosage)', value: 'mg' },
]

export const PRODUCT_SUBTYPE_OPTIONS: { [key in ProductType]: Options[] } = {
  flower: [
    { key: 'Flower', text: 'Flower', value: 'Flower' },
    { key: 'Bottom Shelf', text: 'Bottom Shelf', value: 'Bottom Shelf' },
    { key: 'Bronze', text: 'Bronze', value: 'Bronze' },
    { key: 'Bundle', text: 'Bundle', value: 'Bundle' },
    { key: 'Cold Cured', text: 'Cold Cured', value: 'Cold Cured' },
    {
      key: 'Cold Cured Pre Pack',
      text: 'Cold Cured Pre Pack',
      value: 'Cold Cured Pre Pack',
    },
    { key: 'Elevate', text: 'Elevate', value: 'Elevate' },
    { key: 'First Cut', text: 'First Cut', value: 'First Cut' },
    { key: 'Focus', text: 'Focus', value: 'Focus' },
    { key: 'Gift Box', text: 'Gift Box', value: 'Gift Box' },
    { key: 'Gold', text: 'Gold', value: 'Gold' },
    { key: 'Ground Flower', text: 'Ground Flower', value: 'Ground Flower' },
    { key: 'Indoor', text: 'Indoor', value: 'Indoor' },
    { key: 'Infused Flower', text: 'Infused Flower', value: 'Infused Flower' },
    { key: 'Iron', text: 'Iron', value: 'Iron' },
    { key: 'Legacy', text: 'Legacy', value: 'Legacy' },
    { key: 'Mids', text: 'Mids', value: 'Mids' },
    { key: 'Outdoor', text: 'Outdoor', value: 'Outdoor' },
    { key: 'Platinum', text: 'Platinum', value: 'Platinum' },
    { key: 'Pre Pack', text: 'Pre Pack', value: 'Pre Pack' },
    { key: 'Premium', text: 'Premium', value: 'Premium' },
    {
      key: 'Private Reserve',
      text: 'Private Reserve',
      value: 'Private Reserve',
    },
    { key: 'Reef Leef', text: 'Reef Leef', value: 'Reef Leef' },
    { key: 'Second Cut', text: 'Second Cut', value: 'Second Cut' },
    { key: 'Select', text: 'Select', value: 'Select' },
    { key: 'Select Grind', text: 'Select Grind', value: 'Select Grind' },
    { key: 'Settle', text: 'Settle', value: 'Settle' },
    { key: 'Shake', text: 'Shake', value: 'Shake' },
    { key: 'Shake Pre Pack', text: 'Shake Pre Pack', value: 'Shake Pre Pack' },
    { key: 'Silver', text: 'Silver', value: 'Silver' },
    { key: 'Smalls', text: 'Smalls', value: 'Smalls' },
    {
      key: 'Studio Collection',
      text: 'Studio Collection',
      value: 'Studio Collection',
    },
    { key: 'Sugar Trim', text: 'Sugar Trim', value: 'Sugar Trim' },
    { key: 'Sungrown', text: 'Sungrown', value: 'Sungrown' },
    { key: 'Supreme', text: 'Supreme', value: 'Supreme' },
    {
      key: 'Top Shelf Cold Cured Pre Pack',
      text: 'Top Shelf Cold Cured Pre Pack',
      value: 'Top Shelf Cold Cured Pre Pack',
    },
    { key: 'Trim', text: 'Trim', value: 'Trim' },
    { key: 'Unwind', text: 'Unwind', value: 'Unwind' },
    { key: 'Value', text: 'Value', value: 'Value' },
    { key: 'Value Pre Pack', text: 'Value Pre Pack', value: 'Value Pre Pack' },
    { key: 'Whole Flower', text: 'Whole Flower', value: 'Whole Flower' },
  ],
  edible: [
    { key: 'Baked Goods', text: 'Baked Goods', value: 'Baked Goods' },
    { key: 'Bars', text: 'Bars', value: 'Bars' },
    { key: 'Breath Strips', text: 'Breath Strips', value: 'Breath Strips' },
    { key: 'Candies', text: 'Candies', value: 'Candies' },
    { key: 'Capsules', text: 'Capsules', value: 'Capsules' },
    { key: 'Chocolates', text: 'Chocolates', value: 'Chocolates' },
    { key: 'Cooking', text: 'Cooking', value: 'Cooking' },
    { key: 'Dried Fruit', text: 'Dried Fruit', value: 'Dried Fruit' },
    { key: 'Drink Mixes', text: 'Drink Mixes', value: 'Drink Mixes' },
    { key: 'Drinks', text: 'Drinks', value: 'Drinks' },
    { key: 'Gels', text: 'Gels', value: 'Gels' },
    { key: 'Honeys', text: 'Honeys', value: 'Honeys' },
    { key: 'Ice Creams', text: 'Ice Creams', value: 'Ice Creams' },
    { key: 'Mints', text: 'Mints', value: 'Mints' },
    { key: 'Other', text: 'Other', value: 'Other' },
    { key: 'Pets', text: 'Pets', value: 'Pets' },
    { key: 'Sauces', text: 'Sauces', value: 'Sauces' },
    {
      key: 'Seasoning/Sugar',
      text: 'Seasoning/Sugar',
      value: 'Seasoning/Sugar',
    },
    { key: 'Small Bites', text: 'Small Bites', value: 'Small Bites' },
    { key: 'Snacks', text: 'Snacks', value: 'Snacks' },
    { key: 'Sprays', text: 'Sprays', value: 'Sprays' },
    { key: 'Spreads', text: 'Spreads', value: 'Spreads' },
    { key: 'Sublinguals', text: 'Sublinguals', value: 'Sublinguals' },
    { key: 'Tablets', text: 'Tablets', value: 'Tablets' },
    { key: 'Teas/Coffee', text: 'Teas/Coffee', value: 'Teas/Coffee' },
    { key: 'Troches', text: 'Troches', value: 'Troches' },
  ],
  extract: [
    {
      key: 'Diamonds/Crystals',
      text: 'Diamonds/Crystals',
      value: 'Diamonds/Crystals',
    },
    { key: 'Distillates', text: 'Distillates', value: 'Distillates' },
    { key: 'Hash', text: 'Hash', value: 'Hash' },
    { key: 'Isolates', text: 'Isolates', value: 'Isolates' },
    { key: 'Kief', text: 'Kief', value: 'Kief' },
    { key: 'Live Resins', text: 'Live Resins', value: 'Live Resins' },
    { key: 'Moonrocks', text: 'Moonrocks', value: 'Moonrocks' },
    { key: 'Oils', text: 'Oils', value: 'Oils' },
    { key: 'Other', text: 'Other', value: 'Other' },
    {
      key: 'Rick Simpson Oil (RSO)',
      text: 'Rick Simpson Oil (RSO)',
      value: 'Rick Simpson Oil (RSO)',
    },
    { key: 'Rosins', text: 'Rosins', value: 'Rosins' },
    { key: 'Sauces', text: 'Sauces', value: 'Sauces' },
    { key: 'Shatters', text: 'Shatters', value: 'Shatters' },
    {
      key: 'Syringes/Tankers',
      text: 'Syringes/Tankers',
      value: 'Syringes/Tankers',
    },
    { key: 'Waxes', text: 'Waxes', value: 'Waxes' },
  ],
  merch: [
    { key: 'Clothing', text: 'Clothing', value: 'Clothing' },
    { key: 'Gift Card', text: 'Gift Card', value: 'Gift Card' },
    { key: 'Jewelry', text: 'Jewelry', value: 'Jewelry' },
    { key: 'Kits', text: 'Kits', value: 'Kits' },
    { key: 'Other', text: 'Other', value: 'Other' },
  ],
  grow: [
    { key: 'Clones', text: 'Clones', value: 'Clones' },
    { key: 'Seeds', text: 'Seeds', value: 'Seeds' },
  ],
  tincture: [
    { key: 'Capsules', text: 'Capsules', value: 'Capsules' },
    { key: 'Companions', text: 'Companions', value: 'Companions' },
    { key: 'Mixes', text: 'Mixes', value: 'Mixes' },
    { key: 'Pets', text: 'Pets', value: 'Pets' },
    { key: 'Sprays', text: 'Sprays', value: 'Sprays' },
    { key: 'Sublinguals', text: 'Sublinguals', value: 'Sublinguals' },
    { key: 'Tinctures', text: 'Tinctures', value: 'Tinctures' },
  ],
  gear: [
    { key: 'Accessories', text: 'Accessories', value: 'Accessories' },
    { key: 'Clothing', text: 'Clothing', value: 'Clothing' },
    { key: 'Cones', text: 'Cones', value: 'Cones' },
    { key: 'Gift Card', text: 'Gift Card', value: 'Gift Card' },
    { key: 'Grinders', text: 'Grinders', value: 'Grinders' },
    { key: 'Papers', text: 'Papers', value: 'Papers' },
    { key: 'Paraphernalia', text: 'Paraphernalia', value: 'Paraphernalia' },
    { key: 'Tips', text: 'Tips', value: 'Tips' },
    { key: 'Vaporizers', text: 'Vaporizers', value: 'Vaporizers' },
    { key: 'Wraps', text: 'Wraps', value: 'Wraps' },
  ],
  topical: [
    { key: 'Balms', text: 'Balms', value: 'Balms' },
    { key: 'Bath', text: 'Bath', value: 'Bath' },
    { key: 'Bundles', text: 'Bundles', value: 'Bundles' },
    { key: 'Cosmetics', text: 'Cosmetics', value: 'Cosmetics' },
    { key: 'Creams', text: 'Creams', value: 'Creams' },
    { key: 'Gels', text: 'Gels', value: 'Gels' },
    { key: 'Intimates', text: 'Intimates', value: 'Intimates' },
    { key: 'Kits', text: 'Kits', value: 'Kits' },
    { key: 'Lip Balms', text: 'Lip Balms', value: 'Lip Balms' },
    { key: 'Lotions', text: 'Lotions', value: 'Lotions' },
    { key: 'Oils', text: 'Oils', value: 'Oils' },
    { key: 'Ointments', text: 'Ointments', value: 'Ointments' },
    { key: 'Other', text: 'Other', value: 'Other' },
    { key: 'Patches', text: 'Patches', value: 'Patches' },
    { key: 'Pets', text: 'Pets', value: 'Pets' },
    { key: 'Roll-Ons', text: 'Roll-Ons', value: 'Roll-Ons' },
    { key: 'Salves', text: 'Salves', value: 'Salves' },
    { key: 'Scrubs', text: 'Scrubs', value: 'Scrubs' },
    { key: 'Soaps', text: 'Soaps', value: 'Soaps' },
    { key: 'Sprays', text: 'Sprays', value: 'Sprays' },
    { key: 'Sunscreen', text: 'Sunscreen', value: 'Sunscreen' },
    { key: 'Suppositories', text: 'Suppositories', value: 'Suppositories' },
    { key: 'Topicals', text: 'Topicals', value: 'Topicals' },
  ],
  'pre-roll': [
    { key: 'Blunt Packs', text: 'Blunt Packs', value: 'Blunt Packs' },
    { key: 'Blunts', text: 'Blunts', value: 'Blunts' },
    { key: 'Cannagars', text: 'Cannagars', value: 'Cannagars' },
    { key: 'Infused', text: 'Infused', value: 'Infused' },
    { key: 'Infused Blunts', text: 'Infused Blunts', value: 'Infused Blunts' },
    { key: 'Infused Blunt Packs', text: 'Infused Blunt Packs', value: 'Infused Blunt Packs' },
    { key: 'Infused Packs', text: 'Infused Packs', value: 'Infused Packs' },
    { key: 'Pre Roll Packs', text: 'Pre Roll Packs', value: 'Pre Roll Packs' },
    { key: 'Pre Rolls', text: 'Pre Rolls', value: 'Pre Rolls' },
    { key: 'Thai Sticks', text: 'Thai Sticks', value: 'Thai Sticks' },
  ],
  vape: [
    { key: 'Cartridges', text: 'Cartridges', value: 'Cartridges' },
    { key: 'Cartridge Packs', text: 'Cartridge Packs', value: 'Cartridge Packs' },
    { key: 'Disposables', text: 'Disposables', value: 'Disposables' },
    { key: 'Disposable Packs', text: 'Disposable Packs', value: 'Disposable Packs' },
    { key: 'Inhalation', text: 'Inhalation', value: 'Inhalation' },
    { key: 'Specialty Pods', text: 'Specialty Pods', value: 'Specialty Pods' },
    { key: 'Specialty Pod Packs', text: 'Specialty Pod Packs', value: 'Specialty Pod Packs' },
    { key: 'Vape Kits', text: 'Vape Kits', value: 'Vape Kits' },
    { key: 'Vape Refills', text: 'Vape Refills', value: 'Vape Refills' },
  ],
}

export const SEARCH_LIMIT_OPTIONS: Options[] = [
  { key: '5', text: '5', value: '5' },
  { key: '20', text: '20', value: '20' },
  { key: '50', text: '50', value: '50' },
  { key: '100', text: '100', value: '100' },
  { key: '250', text: '250', value: '250' },
  { key: '500', text: '500', value: '500' },
  { key: '750', text: '750', value: '750' },
  { key: '1000', text: '1000', value: '1000' },
  { key: '1250', text: '1250', value: '1250' },
  { key: '1500', text: '1500', value: '1500' },
  { key: '1750', text: '1750', value: '1750' },
  { key: '2000', text: '2000', value: '2000' },
]

export const PRODUCT_TYPE_ID_BY_KEY: { [key: string]: any } = {}
PRODUCT_TYPE_OPTIONS.forEach((option) => {
  PRODUCT_TYPE_ID_BY_KEY[option.key] = option.id
})

export const LINEAGE_ID_BY_KEY: { [key: string]: any } = {}
LINEAGE_OPTIONS.forEach((option) => {
  LINEAGE_ID_BY_KEY[option.key] = option.id
})

export const PRODUCT_TYPE_KEY_BY_ID: { [key: number]: ProductType } = {}
PRODUCT_TYPE_OPTIONS.forEach((option) => {
  if (typeof option.id === 'number' && option.key) {
    PRODUCT_TYPE_KEY_BY_ID[option.id] = option.key
  }
})

export const PRODUCT_TYPE_NAME_BY_ID: { [key: number]: string } = {}
PRODUCT_TYPE_OPTIONS.forEach((option) => {
  if (typeof option.id === 'number') {
    PRODUCT_TYPE_NAME_BY_ID[option.id] = option.text
  }
})

export const LINEAGE_NAME_BY_ID: { [key: number]: string } = {}
LINEAGE_OPTIONS.forEach((option) => {
  if (typeof option.id === 'number') {
    LINEAGE_NAME_BY_ID[option.id] = option.text
  }
})

export const BRAND_MODE_OPTIONS = [
  {
    key: 'phonetic',
    value: 'phonetic',
    icon: 'play circle outline',
    text: 'Phonetic matching',
  },
  {
    key: 'strict',
    value: 'strict',
    icon: 'target',
    text: 'Strict matching',
  },
  {
    key: 'none',
    value: 'none',
    icon: 'ban',
    text: 'No brand',
  },
]

// Sets the header background color depending on environment
export const HEADER_BACKGROUND_COLOR = process.env.REACT_APP_ENV !== 'prod' ? '#0C645D' : '#5723E7' // Dark Cornflower : Jane Purple

export interface AbbreviatedProduct {
  id: number
  name: string
  brand: string
  brand_subtype: string
  lineage: string
  product_type: number
  image_urls: string[]
}

export interface AbbreviatedProductContainer {
  [key: number]: AbbreviatedProduct
}
